__turbopack_context__.v({
  "sizeM": "fa0CTG_sizeM",
  "sizeS": "fa0CTG_sizeS",
  "sizeXS": "fa0CTG_sizeXS",
  "sizeXXS": "fa0CTG_sizeXXS",
  "timestamp": "fa0CTG_timestamp",
  "toneDefault": "fa0CTG_toneDefault",
  "toneMuted": "fa0CTG_toneMuted",
});
